
  
  export const featuredProducts = [
    { img: 'img/featur-1.jpg', name: 'Big Banana', price: '2.99', oldPrice: '4.11' },
    { img: 'img/featur-2.jpg', name: 'Big Banana', price: '2.99', oldPrice: '4.11' },
    { img: 'img/featur-3.jpg', name: 'Big Banana', price: '2.99', oldPrice: '4.11' },
  ];
